import React from "react";
import { FormattedMessage } from "react-intl";
import { useToLocaleDate } from "b2b/i18n";

import createBaseRenderer from "./createBaseRenderer";
import { MESSAGES } from "./i18n/useMessages";

export default createBaseRenderer({
  name: "aktivni",
  placeholderText: "17. 02. 20204",
  content: ({ val }) => {
    const vylukaOd = useToLocaleDate()(val.vylukaOd);
    const vylukaDo = useToLocaleDate()(val.vylukaDo);
    const message = val.aktivni ? MESSAGES.ano : MESSAGES.ne;
    return (
      <>
        <FormattedMessage {...message} />
        {vylukaOd && vylukaDo && (
          <div className="b2b-Renderer-vyluka">
            <span className="b2b-Renderer-vylukaLabel">
              <FormattedMessage {...MESSAGES.vyluka} />
            </span>
            <span className="b2b-Renderer-vylukaOd">{vylukaOd}</span>
            <span className="b2b-Renderer-vylukaDo">{vylukaDo}</span>
          </div>
        )}
      </>
    );
  }
});
